import {
    getLogoInfo,
    getUserMenuInfo as getDefaultUserMenu,
} from '@eb/site-header';
import { getUserMenuInfo as getOrganizationUserMenuInfo } from '../organizations';
import { constants } from '@eb/event-create-publish-utils';
import { getOrganizationImageUrl } from '../organizations/utils';

const { ORG_LOGO_BK_COLOR, ORG_ICON_COLOR, HEADER_LABELS } = constants;

export const getOrganizerLogoInfo = ({
    url,
    requestPath,
    logoOptions = {},
    iconColor = ORG_LOGO_BK_COLOR,
}) =>
    getLogoInfo(url, requestPath, {
        iconColor,
        ...logoOptions,
    });

export const getPrimaryActionFromErrorDetail = (
    navigate,
    errorDetail,
    baseUrl,
    eventId,
) => {
    let primaryAction;

    if (errorDetail.getPrimaryActionLink) {
        const url = errorDetail.getPrimaryActionLink(baseUrl, eventId);

        primaryAction = {
            primaryText:
                errorDetail.primaryActionText || HEADER_LABELS.VIEW_LABEL,
            primaryType: 'link',
            onPrimaryAction: () => {
                if (errorDetail.isActionLinkExternal) {
                    window.location.href = url;
                } else {
                    navigate(url);
                }
            },
        };
    }

    return primaryAction;
};

export const getSecondaryActionFromErrorDetail = (
    navigate,
    errorDetail,
    baseUrl,
    eventId,
) => {
    let secondaryAction;

    if (errorDetail.getSecondaryActionLink) {
        const url = errorDetail.getSecondaryActionLink(baseUrl, eventId);

        secondaryAction = {
            secondaryText:
                errorDetail.secondaryActionText || HEADER_LABELS.VIEW_LABEL,
            secondaryType: 'link',
            onSecondaryAction: () => {
                if (errorDetail.isActionLinkExternal) {
                    window.location.href = url;
                } else {
                    navigate(url);
                }
            },
        };
    }

    return secondaryAction;
};

export const getUserMenuInfo = ({
    env,
    user,
    organization = {},
    hideOrganizationSwitch = false,
    onlyUseAnchorLinks,
    featureFlags,
}) => {
    const { serverUrl, adminServerUrl, logoutUrl, requestPath } = env;
    const {
        publicId: publicUserId,
        fullName,
        email,
        thumbnailUrl,
        isStaff,
        hasTikibar,
        numOrders,
        numSavedEvents,
        numFollowing,
        firstName,
    } = user;

    if (user.usesNewPermissions) {
        return {
            ...getOrganizationUserMenuInfo({
                showEventsLink: true,
                organizationName: organization.name,
                // getOrganizationImageUrl provides a default that isn't compatible (design)
                // with the headers in New Create. Bypass this default by checking for image.
                organizationImageUrl:
                    organization?.image &&
                    getOrganizationImageUrl(organization),
                hideOrganizationSwitch,
                publicUserId,
                requestPath,
                serverUrl,
                email,
                fullName,
                userImageUrl: thumbnailUrl,
                isStaff,
                adminServerUrl,
                hasTikibar,
                logoutUrl,
                numOrders,
                numSavedEvents,
                numFollowing,
                onlyUseAnchorLinks,
                featureFlags,
            }),
            iconColor: ORG_ICON_COLOR,
            label: firstName,
        };
    }

    return getDefaultUserMenu({
        serverUrl,
        adminServerUrl,
        logoutUrl,
        requestPath,
        user,
        iconColor: ORG_ICON_COLOR,
        featureFlags,
    });
};
